import type { CustomerOrder, CustomerOrderInvoice } from '../customerOrdersApi'
import { ORDER_LIST_LIMIT as ORDERS_LIST_LIMIT, useOrdersListWithCheckoutSync } from './useOrdersListWithCheckoutSync'
import { useOrderDetailBundle } from './useOrderDetailBundle'

export const ORDER_LIST_LIMIT = ORDERS_LIST_LIMIT

type UseCustomerOrdersInput = {
  authenticated: boolean
  token: string | null
  loadOrdersList: boolean
  isOrderDetailRoute: boolean
  orderDetailId: string
  enableCheckoutConsistencyPolling: boolean
}

export type UseCustomerOrdersResult = {
  orders: CustomerOrder[]
  ordersLoading: boolean
  ordersError: string
  retryOrders: () => void
  orderDetail: CustomerOrder | null
  orderDetailLoading: boolean
  orderDetailError: string
  orderInvoices: CustomerOrderInvoice[]
  orderInvoicesLoading: boolean
  orderInvoicesError: string
  checkoutSyncActive: boolean
}

export const useCustomerOrders = ({
  authenticated,
  token,
  loadOrdersList,
  isOrderDetailRoute,
  orderDetailId,
  enableCheckoutConsistencyPolling,
}: UseCustomerOrdersInput): UseCustomerOrdersResult => {
  const {
    orders,
    ordersLoading,
    ordersError,
    retryOrders,
    checkoutSyncActive,
  } = useOrdersListWithCheckoutSync({
    authenticated,
    token,
    loadOrdersList,
    enableCheckoutConsistencyPolling,
  })

  const {
    orderDetail,
    orderDetailLoading,
    orderDetailError,
    orderInvoices,
    orderInvoicesLoading,
    orderInvoicesError,
  } = useOrderDetailBundle({
    authenticated,
    token,
    isOrderDetailRoute,
    orderDetailId,
  })

  return {
    orders,
    ordersLoading,
    ordersError,
    retryOrders,
    orderDetail,
    orderDetailLoading,
    orderDetailError,
    orderInvoices,
    orderInvoicesLoading,
    orderInvoicesError,
    checkoutSyncActive,
  }
}
